import Card, {CardProps} from 'antd/es/card';
import {AccountStatus, useUserMasterAccountQuery} from 'api/generated';
import {AnchorLink, Hint} from 'components';
import {PropertyList} from 'components/PropertyList';
import {formatSignUpAnchorLink, formatSignUpLink} from 'lib/formaters';
import {accountStatusLabels} from 'lib/labels';
import React from 'react';
import {Link} from 'react-router-dom';

export const MasterAccountInfo: React.FC = () => {
  const {data: masterAccountData, loading} = useUserMasterAccountQuery();
  const masterAccount = masterAccountData?.userMasterAccount;

  const cardProps: CardProps = {
    size: 'small',
    loading,
    type: 'inner',
    style: {
      marginBottom: 25
    }
  };

  if (!masterAccount) return <Card {...cardProps} title="Account details" />;

  return (
    <>
      <h2>Account information</h2>
      <Card {...cardProps} title="Account details">
        <PropertyList
          omitEmpty
          properties={[
            {
              label: 'ID',
              copyable: {text: masterAccount.id},
              value: (
                <Link to={`/payments?masterAccountId=${masterAccount.id}`}>{masterAccount.id}</Link>
              )
            },
            {
              label: 'Name',
              value: masterAccount.name
            },
            {
              label: 'Status',
              value: accountStatusLabels[masterAccount.status as AccountStatus]
            },
            {
              label: 'Promo code',
              value: masterAccount.promoCode
            },
            {
              label: (
                <Hint
                  message={
                    <>
                      Share this link with your merchants to allow them to sign up with MONEI. More
                      information{' '}
                      <AnchorLink href="https://docs.monei.com/monei-connect/">here</AnchorLink>.
                    </>
                  }>
                  Sign up link
                </Hint>
              ),
              copyable: {text: formatSignUpLink(masterAccount.promoCode)},
              value: formatSignUpAnchorLink(masterAccount.promoCode)
            }
          ]}
        />
      </Card>
    </>
  );
};
